import { useState, useEffect } from 'react';
import { Hotel, ExternalLink, RefreshCw, AlertCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function HotelReservation() {
  const { getAuthHeader, user } = useAuth();
  const [formUrl, setFormUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/settings/hotel-reservation`, getAuthHeader());
        setFormUrl(response.data?.form_url || '');
        setError(null);
      } catch (err) {
        console.error('Settings fetch error:', err);
        setError('Form ayarları yüklenemedi');
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, [getAuthHeader]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (error || !formUrl) {
    return (
      <div className="space-y-6">
        <div>
          <h1 data-testid="hotel-page-title" className="text-2xl font-bold font-[Manrope]">Otel Rezervasyon</h1>
          <p className="text-muted-foreground">Otel rezervasyon formu</p>
        </div>
        
        <Card className="border-dashed">
          <CardContent className="py-12">
            <div className="flex flex-col items-center justify-center text-center text-muted-foreground">
              <AlertCircle className="h-12 w-12 mb-4 opacity-50" />
              <h3 className="text-lg font-medium mb-2">Form Henüz Ayarlanmamış</h3>
              <p className="text-sm max-w-md">
                Otel rezervasyon formu admin tarafından henüz ayarlanmamış. 
                Lütfen yöneticinize başvurun.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  // Check if it's a Google Sheets/Forms URL
  const isGoogleUrl = formUrl.includes('docs.google.com') || formUrl.includes('forms.google.com');

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 data-testid="hotel-page-title" className="text-2xl font-bold font-[Manrope]">Otel Rezervasyon</h1>
          <p className="text-muted-foreground">Otel rezervasyonu yapmak için aşağıdaki formu kullanın</p>
        </div>
        <Button
          data-testid="hotel-open-external"
          variant="outline"
          onClick={() => window.open(formUrl, '_blank')}
          className="gap-2"
        >
          <ExternalLink className="h-4 w-4" />
          Yeni Sekmede Aç
        </Button>
      </div>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base flex items-center gap-2">
            <Hotel className="h-4 w-4" />
            Rezervasyon Formu
          </CardTitle>
          <CardDescription>
            Aşağıdaki formu doldurarak otel rezervasyonu yapabilirsiniz
          </CardDescription>
        </CardHeader>
        <CardContent>
          {isGoogleUrl ? (
            <div className="w-full rounded-lg overflow-hidden border bg-white">
              <iframe
                src={formUrl.replace('/edit', '/viewform').replace('?usp=sharing', '')}
                width="100%"
                height="800"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                title="Otel Rezervasyon Formu"
                className="w-full"
              >
                Yükleniyor...
              </iframe>
            </div>
          ) : (
            <div className="text-center py-8">
              <Button onClick={() => window.open(formUrl, '_blank')} className="gap-2">
                <ExternalLink className="h-4 w-4" />
                Formu Aç
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
